/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/4/25 11:00
 */
import { Affix, Icon } from 'antd'
import { useEffect, useState } from 'react'
import getUsername from '../getUsername'
import './layoutHeader.less'

interface propTypes {
  lang: string
  activeHref: string | undefined
  i18nVisible: boolean
  fixed?: boolean
  userInfo?: UserInfo
}

const LayoutHeader = (props: propTypes) => {
  const navs = [
    {
      name: __('Home'),
      href: '/',
    },
    {
      name: __('Services'),
      href: '/services/',
    },
    {
      name: __('Product'),
      items: [
        {
          name: 'BuckyDrop',
          href: '/plugin_service/',
        },
        {
          name: __('BuckyShop'),
          href: '/buckyshop/',
        },
        {
          name: 'Open API',
          href: '/open_api/',
        },
      ],
    },
    {
      name: __('Pricing'),
      href: '/pricing/',
    },
    {
      name: __('Account Manager'),
      href: '/manager/',
    },
    {
      name: __('Affiliates'),
      href: '/promotion_alliance/',
    },
    {
      name: __('Forums'),
      href: 'http://bbs.buckydrop.com',
      i18n: [],
      type: 'blank',
    },
    {
      name: __('Support'),
      items: [
        {
          name: __('Help Center'),
          href: '/help/',
        },
        {
          name: __('BuckyDrop 101'),
          href: '/info_graphic/',
          type: 'blank',
        },
        {
          name: __('Contact Us'),
          href: '/contact_us/',
        },
        {
          name: __('About Us'),
          href: '/about_us/',
        },
      ],
    },
  ]

  const [i18nLink, setI18nLink] = useState('/cn/')

  /**
   * 监听注册来源，将渠道商与代理商标识写入 sessionStorage
   * 注册的时候读取 sessionStorage 回传至服务器并记录
   */
  const setAgentTag = () => {
    const unSerialize = (queryString: string, key = undefined) => {
      const reg = /([^?&=]+)=([^&=]+)/g
      const query = {}
      let result
      while ((result = reg.exec(queryString)) !== null) {
        const [key, value] = result
        query[key] = value
      }
      // @ts-ignore
      return key ? (query[key] || query) : query
    }

    const { tn } = unSerialize(window.location.search) as { tn: string }
    tn && window.sessionStorage.setItem('agent_code', tn)
  }

  useEffect(() => {
    const { lang } = props
    const { pathname } = window.location
    let href = ''

    if (window.location.href) {
      href = window.location.href // eslint-disable-line
    }

    setAgentTag()

    const getLink = pathname === '/' ? '/cn/' : href.replace(`/${lang}`, lang === 'en' ? '/cn' : '/en')
    setI18nLink(getLink)
  }, [props])

  const { lang, activeHref, i18nVisible, userInfo } = props
  const userName = getUsername(userInfo)

  return (
    <Affix
      className='ant-affix-header-wrap'
      offsetTop={0}
    >
      <header className='layout-header'>
        <div className='layoutHeader_headerContainer'>
          <div className='left part'>
            <a
              href={`/${lang}/`}
              className='logo'
            />
            <nav className='menu'>
              {
                navs.map(el => (
                  el.items
                    ? (
                      <LayoutHeader.Items
                        type={el.type}
                        key={el.name}
                        lang={lang}
                        activeHref={activeHref}
                        name={el.name}
                        items={el.items}
                      />
                    )
                    : (
                      <LayoutHeader.Item
                        type={el.type}
                        key={el.name}
                        lang={lang}
                        activeHref={activeHref}
                        name={el.name}
                        href={el.href}
                        i18n={el.i18n}
                      />
                    )
                ))
              }
            </nav>
          </div>
          <div className='right part'>
            <div
              className='fb-like fb-style'
              data-href='https://www.facebook.com/BuckyDrop.Official/'
              data-layout='button_count'
              data-action='like'
              data-size='large'
              data-show-faces='true'
              data-share='false'
            />
            {
              i18nVisible &&
              <a
                href={i18nLink}
                className={`${lang} i18n`}
              >
                <i className='front' />
                <i className='back' />
              </a>
            }
            {
              userInfo
                ? (
                  <div className='userInfo-box online'>
                    <div className='user-info'>
                      <div className='user-info-name'>
                        <p className='user-name'>
                          {userName}
                        </p>
                      </div>
                    </div>
                    <a
                      className='sign-up-btn'
                      href='/en/admin/home'
                    >{__('Switch to Admin')}
                    </a>
                  </div>
                )
                : (
                  <div className='userInfo-box offline'>
                    <a
                      className='sign-in-btn'
                      href='/en/login/'
                    >{__('Sign In')}
                    </a>
                    <a
                      className='sign-up-btn sign-up-btn-fixWidth'
                      href='/en/register'
                    >{lang === 'en' ? 'Get Started' : '立即注册'}
                    </a>
                  </div>
                )
            }
          </div>
        </div>
      </header>
    </Affix>
  )
}

interface itemPropTypes {
  lang: string
  activeHref?: string | undefined
  name?: string
  href?: string
  i18n?: string[]
  type?: string
}

LayoutHeader.Item = function Item (props: itemPropTypes) {
  const { type, name, href = '', lang, activeHref = '', i18n = ['cn', 'en'] } = props
  const hrefLang = (!/\//.test(href) || !i18n.length) ? '' : `/${lang}`
  return (
    <a
      target={type === 'blank' ? '_blank' : ''}
      className={`item${href === activeHref ? ' active' : ''}`}
      key={href}
      href={hrefLang + href}
    ><span className='navName'>{name}</span>
    </a>
  )
}

interface innerItemsType {
  name?: string
  href?: string
  i18n?: []
}

interface itemsPropType {
  lang: string
  activeHref: string | undefined
  name: string
  type?: string
  items?: innerItemsType[]
}

LayoutHeader.Items = function Items (props: itemsPropType) {
  const { lang, activeHref, name, items } = props
  let active
  let itemsElement
  if (items) {
    active = items.map(el => el.href).includes(activeHref)
    itemsElement = items.map(el => (
      <LayoutHeader.Item
        key={el.href}
        lang={lang}
        activeHref={activeHref}
        {...el}
      />
    ))
  }

  return (
    <div className='child-item'>
      <a
        className={`item${active ? ' active' : ''}`}
      >
        <span className='navName'>{name}</span>
        <Icon
          type='down'
          theme='outlined'
          style={{
            marginLeft: 10,
            verticalAlign: 'middle',
          }}
        />
      </a>
      <nav className={`child-menu${active ? ' active' : ''}`}>{itemsElement}</nav>
    </div>
  )
}

export default LayoutHeader
